import React from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Breadcrumb } from '@paygreen/paygreen-ui';

const AdminCharityBreadCrumb = ({ t, accountId }) => {
    const isCharityDonations = !!useRouteMatch(
        '/admin/charities/:accountId/charity-donations',
    );

    let finalCrumbs = () => {
        switch (true) {
            case isCharityDonations:
                return [
                    {
                        url: '/admin/charities',
                        label: t('admin.charities.title'),
                    },
                    {
                        url: `/admin/charities/${accountId}`,
                        label: t('admin.charity.title'),
                    },
                    {
                        url: '/',
                        label: t('shopDonations.title'),
                    },
                ];
            default:
                return [
                    {
                        url: '/admin/charities',
                        label: t('admin.charities.title'),
                    },
                    {
                        url: '',
                        label: t('admin.charity.title'),
                    },
                ];
        }
    };

    return <Breadcrumb colorTheme="quaternary" elements={finalCrumbs()} />;
};

AdminCharityBreadCrumb.propTypes = {
    accountId: PropTypes.string,
};

export default withTranslation('common')(AdminCharityBreadCrumb);
